module.exports = __webpack_public_path__ + "media/images/icon-clock-green-a0aff7ee47d59152e3cca9315d15361e.png";